import { useQuery } from '@tanstack/react-query';
import { sharedDocumentsApi, type OpenSharedDocumentResult } from '../infrastructure/sharedDocuments.api';

// Opening a shared document is a one-shot guest read (the backend counts each open as an access), so refetching
// is disabled — it runs once per token. No auth: the token in the URL is the only credential.
export const sharedDocumentKeys = {
  all: ['shared-document'] as const,
  byToken: (token: string) => ['shared-document', token] as const,
};

export function useSharedDocumentQuery(token: string | undefined) {
  return useQuery<OpenSharedDocumentResult>({
    queryKey: sharedDocumentKeys.byToken(token ?? ''),
    queryFn: () => sharedDocumentsApi.open(token as string),
    enabled: Boolean(token),
    retry: false,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
